<template>
  <div class="category-quote-wrapper mb-4">
    <SlideGroup
      v-if="categoryQuotes.length"
      :list="categoryQuotes"
      :lazy-load-items="categoryQuotes.length"
      :show-arrows="false"
      wheel
    >
      <template #item="{ item }">
        <CategoryQuoteCard :quote="item" class="mr-2" />
      </template>
    </SlideGroup>
  </div>
</template>

<script>
import CategoryQuoteCard from '@/components/views/CategoryView/CategoryQuote/CategoryQuoteCard.vue';
import SlideGroup from '@/components/views/SlideGroup/SlideGroup.vue';

export default {
  name: 'CategoryQuote',
  components: { CategoryQuoteCard, SlideGroup },
  props: {
    category: {
      type: String,
      required: false
    }
  },
  data() {
    return {};
  },
  computed: {
    categoryQuotes() {
      const categoryInfo = this.$store.getters['LibraryStore/getCategoryInfo'](
        this.category
      );

      return categoryInfo?.quotes || [];
    }
  },
  methods: {}
};
</script>

<style lang="less" src="./CategoryQuote.less"></style>
